export default __webpack_public_path__ + "static/media/classroomImg3.508bc864.svg";